import { render, staticRenderFns } from "./PlatformSection.vue?vue&type=template&id=28e68e94&scoped=true"
import script from "./PlatformSection.vue?vue&type=script&lang=js"
export * from "./PlatformSection.vue?vue&type=script&lang=js"
import style0 from "./PlatformSection.vue?vue&type=style&index=0&id=28e68e94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e68e94",
  null
  
)

export default component.exports